import React from 'react';
import './Unauthorized.css';

/**
 * Unauthorized Page
 *
 * Displayed when a user successfully authenticates but does not have
 * the required permissions to access the application.
 */
function Unauthorized() {
  const handleLogout = () => {
    // Clear all auth data
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to home (which will trigger re-authentication)
    window.location.href = '/';
  };

  const handleContactSupport = () => {
    // Open email client with pre-filled support request
    const subject = encodeURIComponent('PAT Access Request');
    const body = encodeURIComponent(
      'Hello,\n\n' +
        'I am trying to access the Program Architecture Tool (PAT) but received an unauthorized error.\n\n' +
        'Please grant me access to the application.\n\n' +
        'Thank you!'
    );
    window.location.href = `mailto:eadvapps@asu.edu?subject=${subject}&body=${body}`;
  };

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <div className="lock-icon">
          <svg
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
              fill="#8C1D40"
            />
          </svg>
        </div>

        <h1>Access Denied</h1>
        <h2>You do not have permission to access this application.</h2>

        <div className="unauthorized-info">
          <p>
            Your account has been authenticated successfully, but you are not
            authorized to use the Program Architecture Tool (PAT).
          </p>
          <p className="help-text">
            If you believe you should have access to this application, please
            contact your administrator or the EADV support team.
          </p>
        </div>

        <div className="unauthorized-actions">
          <button
            className="unauthorized-button primary"
            onClick={handleContactSupport}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              style={{ marginRight: '8px' }}
            >
              <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM13 14h-2v-2h2v2zm0-4h-2V6h2v4z" />
            </svg>
            Contact Support
          </button>

          <button
            className="unauthorized-button secondary"
            onClick={handleLogout}
          >
            Try Different Account
          </button>
        </div>

        <div className="contact-info">
          <p>
            <strong>Need access?</strong>
          </p>
          <p>
            Contact: <a href="mailto:eadvapps@asu.edu">eadvapps@asu.edu</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
